import appleTouchIcon from "./assets/apple-touch-icon.png";
import contactImage from "./assets/contact-youtube.jpg";
import faviconImage from "./assets/favicon.png";
import heroImage from "./assets/hero-george-vidal.png";
import logoImage from "./assets/logo-george-vidal.png";

export type SocialIconName = "bandcamp" | "beatport" | "facebook" | "instagram" | "tiktok" | "twitch" | "youtube";

export type SiteContent = {
  meta: {
    title: string;
    author: string;
    description: string;
    url: string;
    previewImage: string;
    favicon: string;
    appleTouchIcon: string;
  };
  images: {
    logo: string;
    hero: string;
    contact: string;
  };
  cta: {
    label: string;
    href: string;
  };
  socialLinks: Array<{
    label: string;
    href: string;
    icon: SocialIconName;
  }>;
  instagram: {
    profileUrl: string;
    handle: string;
    embedPosts: string[];
  };
  spotify: {
    title: string;
    src: string;
  };
  contact: {
    heading: string;
    emails: string[];
  };
  footer: {
    copyright: string;
  };
};

export const defaultSiteContent: SiteContent = {
  meta: {
    title: "George Vidal",
    author: "George Vidal / Dj, Producer",
    description: "George Vidal / Dj, Producer",
    url: "https://georgevidal.com/george-vidal",
    previewImage: heroImage,
    favicon: faviconImage,
    appleTouchIcon,
  },
  images: {
    logo: logoImage,
    hero: heroImage,
    contact: contactImage,
  },
  cta: {
    label: "CONNECT AND LISTEN",
    href: "https://linktr.ee/djgeorgevidal",
  },
  socialLinks: [
    {
      label: "Bandcamp",
      href: "https://djgeorgevidal.bandcamp.com/",
      icon: "bandcamp",
    },
    {
      label: "Beatport",
      href: "https://www.beatport.com/search?q=George%20Vidal",
      icon: "beatport",
    },
    {
      label: "Facebook",
      href: "https://www.facebook.com/djgeorgevidal",
      icon: "facebook",
    },
    {
      label: "Instagram",
      href: "https://www.instagram.com/djgeorgevidal/",
      icon: "instagram",
    },
    {
      label: "TikTok",
      href: "https://www.tiktok.com/@djgeorgevidal",
      icon: "tiktok",
    },
    {
      label: "Twitch",
      href: "https://www.twitch.tv/djgeorgevidal",
      icon: "twitch",
    },
    {
      label: "YouTube",
      href: "https://www.youtube.com/@djgeorgevidal_",
      icon: "youtube",
    },
  ],
  instagram: {
    profileUrl: "https://www.instagram.com/djgeorgevidal/",
    handle: "@djgeorgevidal",
    embedPosts: [
      "https://www.instagram.com/djgeorgevidal/",
      "https://www.instagram.com/djgeorgevidal/",
      "https://www.instagram.com/djgeorgevidal/",
      "https://www.instagram.com/djgeorgevidal/",
    ],
  },
  spotify: {
    title: "George Vidal on Spotify",
    src: "https://open.spotify.com/embed/artist/1DLWVR5wlHknJpG19cBaal?utm_source=generator&theme=0",
  },
  contact: {
    heading: "BOOKINGS & CONTACT",
    emails: ["carlos@georgevidal.com", "georgevidal@georgevidal.com"],
  },
  footer: {
    copyright: "Copyright © 2024 George Vidal - Todos los derechos reservados.",
  },
};

export const siteMeta = defaultSiteContent.meta;
export const images = defaultSiteContent.images;
export const cta = defaultSiteContent.cta;
export const socialLinks = defaultSiteContent.socialLinks;
export const spotify = defaultSiteContent.spotify;
export const contact = defaultSiteContent.contact;
export const footer = defaultSiteContent.footer;
